// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"0ceac780","233":"2c740184","369":"e03ac151","777":"d85915b3","936":"c448936c"}[chunkId] + ".js";
};